import { render, staticRenderFns } from "./MetricsBox.vue?vue&type=template&id=425cc19c&scoped=true&"
import script from "./MetricsBox.vue?vue&type=script&lang=ts&"
export * from "./MetricsBox.vue?vue&type=script&lang=ts&"
import style0 from "./MetricsBox.vue?vue&type=style&index=0&id=425cc19c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425cc19c",
  null
  
)

export default component.exports